import type { ProductSize } from 'product/types'
import type { Stock, StockAvailability } from 'product/types/Stock'
import { useMemo } from 'react'
import type { FullProduct } from '../../../types/FullProduct'

interface UseReduceProductStockProps {
	product: FullProduct
}

export function useReduceProductStock({
	product,
}: UseReduceProductStockProps): Stock {
	return useMemo(
		() => ({
			colors: product.colors.reduce(
				(acc, color) => {
					acc[color.id] = {
						sizes: color.sizes.reduce(
							(sizesAcc, size) => {
								sizesAcc[size.id] = size
								return sizesAcc
							},
							{} as Record<ProductSize['id'], StockAvailability>
						),
					}
					return acc
				},
				{} as Stock['colors']
			),
		}),
		[product]
	)
}
